export const FAILED_SOCKET_EVENTS_SESSIONSTORAGE_KEY = 'SOCKET_FAILED_EVENTS';

export const FAILED_SOCKET_EVENTS_SESSIONSTORAGE_DEFAULT_VALUE = {};

export const SOCKET_EVENTS = {
  BLUR_EVENT: 'BLUR_EVENT',
  FOCUS_EVENT: 'FOCUS_EVENT',
  GET_WEBCAM_SNAPSHOT_URL: 'GET_WEBCAM_SNAPSHOT_URL',
  LOCATION_URL_CHANGED: 'LOCATION_URL_CHANGED',
  PROCTOR_INIT: 'PROCTOR_INIT',
  WEBCAM_SNAPSHOT_URL: 'WEBCAM_SNAPSHOT_URL',
  WEBCAM_ENABLED: 'WEBCAM_ENABLED',
  WEBCAM_DISABLED: 'WEBCAM_DISABLED',
  WEBCAM_ERROR_START: 'WEBCAM_ERROR_START',
  WEBCAM_ERROR_DURATION: 'WEBCAM_ERROR_DURATION',
  TIME_MISMATCH: 'TIME_MISMATCH',
  TRACK: 'TRACK',
  VALIDATE_SESSION: 'VALIDATE_SESSION',
  INRCREMENT_BROWSER_TOLERANCE: 'INCR_BROWSER_TOLERANCE',
  BROWSER_TOLERANCE: 'BROWSER_TOLERANCE',
  MONITOR_ADDED: 'monitor_added',
  AUDIO_COMPLETION_COUNT: 'AUDIO_COMPLETION_COUNT',
  AUDIO_PLAY_INIT: 'AUDIO_PLAY_INIT',
  VOICE_DETECTED: 'VOICE_DETECTED',
};

export const WEBSOCKET_EVENT_SEQUENCE_SESSIONSTORAGE_KEY =
  'WEBSOCKET_EVENT_SEQUENCE_';

export const WEBSOCKET_EVENT_SEQUENCE_SESSIONSTORAGE_DEFAULT_VALUE = 1;
